const translations = {
  "en": {
    "Asset recognition failed. Please select another method to connect your assets.": "Asset recognition failed. Please select another method to connect your assets.",
    "Asset save failed. Please select another method to connect your assets.": "Asset save failed. Please select another method to connect your assets.",
    "No assets detected in the file. Please upload a different file.": "No assets detected in the file. Please upload a different file.",
    "No assets detected in the image. Please upload a different image.": "No assets detected in the image. Please upload a different image."
  },
  "zh-tw": {
    "Asset recognition failed. Please select another method to connect your assets.": "資產辨識失敗。請選擇其他方式連接你的資產。",
    "Asset save failed. Please select another method to connect your assets.": "資產儲存失敗。請選擇其他方式連接你的資產。",
    "No assets detected in the file. Please upload a different file.": "檔案中未偵測到任何資產。請上傳其他檔案。",
    "No assets detected in the image. Please upload a different image.": "圖片中未偵測到任何資產。請上傳其他圖片。"
  }
};

export default translations;
